import { render, staticRenderFns } from "./ScreenSpecs.vue?vue&type=template&id=46656f4c&scoped=true"
import script from "./ScreenSpecs.vue?vue&type=script&lang=ts"
export * from "./ScreenSpecs.vue?vue&type=script&lang=ts"
import style0 from "./ScreenSpecs.vue?vue&type=style&index=0&id=46656f4c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46656f4c",
  null
  
)

export default component.exports